if (sessionStorage.getItem('popup_subscribed') === 'true') {
  window.isNewsletterModalShow = true;
  if (window.location.search.includes('form_type=customer')) {
    window.history.replaceState({}, '', window.location.pathname);
  }

  function hideNewsletterAlerts() {
    document.querySelectorAll('[id*="NewsletterAlertModal"]').forEach(el => {
      el.setAttribute('hidden', '');
      el.style.display = 'none';
      if (el.close) el.close();
    });
    document.querySelectorAll('.fixed-overlay[aria-controls*="NewsletterAlertModal"]').forEach(el => el.remove());
  }

  hideNewsletterAlerts();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideNewsletterAlerts);
  }
}

if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat(['data-trigger-open', 'data-repeat-open']);
      }

      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        this.triggerOpen = this.dataset.triggerOpen;
        this.repeatOpen = this.dataset.repeatOpen;
        this.cookieName = 'hypertheme:popup';

        this.flagFormSubmit();
        this.stripCaptcha();
        window.FoxTheme.DOMready(this.handleOpen.bind(this));
      }

      stripCaptcha() {
        const selectors = [
          '.shopify-challenge__container',
          '.g-recaptcha',
          '.grecaptcha-badge',
          '.h-captcha',
          '.cf-turnstile',
          '[data-shopify-challenge]',
          'iframe[src*="recaptcha"]',
          'iframe[src*="hcaptcha"]',
          'iframe[src*="turnstile"]'
        ];
        const remove = () => {
          this.querySelectorAll(selectors.join(',')).forEach(el => el.remove());
        };
        remove();
        const observer = new MutationObserver(remove);
        observer.observe(this, { childList: true, subtree: true });
      }

      flagFormSubmit() {
        const form = this.querySelector('.subscription-popup__form form, .subscription-popup__form [is="newsletter-form"]');
        if (!form) return;
        form.addEventListener('submit', () => {
          sessionStorage.setItem('popup_subscribed', 'true');
          this.applyDiscountSilently();
        });
      }

      applyDiscountSilently() {
        const codeInput = this.querySelector('.subscription-popup__code input[readonly]');
        const code = codeInput && codeInput.value && codeInput.value.trim();
        if (!code) return;
        try {
          sessionStorage.setItem('popup_discount_pending', code);
        } catch (e) {}
        const url = '/discount/' + encodeURIComponent(code) + '?redirect=/cart.js';
        fetch(url, { method: 'GET', credentials: 'same-origin', cache: 'no-store' }).catch(() => {});
      }

      showCodeReveal() {
        const formBlock = this.querySelector('.subscription-popup__form');
        const textBlock = this.querySelector('.subscription-popup__text');
        const heading = this.querySelector('.subscription-popup__title h3');
        const codeBlock = this.querySelector('.subscription-popup__code');

        if (formBlock) formBlock.style.display = 'none';
        if (textBlock) textBlock.innerHTML = '<p class="rich-text__text rte text-subtext text-base">Thanks for subscribing! Your discount has been applied to your cart:</p>';
        if (heading) heading.textContent = "You're In!";
        if (codeBlock) {
          codeBlock.style.display = 'flex';
          this.applyDiscountSilently();
        }
      }

      prepareToShow() {
        super.prepareToShow();
        this.setRepeatOpen();
      }

      handleOpen() {
        if (Shopify.designMode) return;

        if (sessionStorage.getItem('popup_subscribed') === 'true') {
          sessionStorage.removeItem('popup_subscribed');
          this.showCodeReveal();
          this.show();
          return;
        }

        let savedData = FoxTheme.utils.getStorage(this.cookieName);
        if (savedData && savedData.opened) {
          return false;
        }

        switch (this.triggerOpen) {
          case 'delay':
            setTimeout(() => {
              this.show();
            }, 5000);
            break;
          case 'scroll_down':
            this.triggerAfterScroll(700, this.show.bind(this));
            break;
          default:
            this.show();
            break;
        }
      }

      triggerAfterScroll(offset = 500, trigger) {
        let opened = false;
        const start = 0;
        window.addEventListener('scroll', (e) => {
          let scrollTop =
            window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (scrollTop - start > offset && !opened) {
            trigger();
            opened = true;
            return;
          }
        });
      }

      setRepeatOpen() {
        if (Shopify.designMode) return;

        let expires;
        switch (this.repeatOpen) {
          case 'no_repeat':
            expires = 365;
            break;
          case 'every_3_mins':
            expires = 3 / 60 / 24;
            break;
          case 'every_5_mins':
            expires = 5 / 60 / 24;
            break;
          case 'every_10_mins':
            expires = 1 / 6 / 24;
            break;
          case 'every_15_mins':
            expires = 15 / 60 / 24;
            break;
          case 'every_30_mins':
            expires = 1 / 2 / 24;
            break;
          case 'every_1_hr':
            expires = 1 / 24;
            break;
          case 'every_6_hrs':
            expires = 6 / 24;
            break;
          case 'every_12_hrs':
            expires = 1 / 2;
            break;
          case 'every_day':
            expires = 1;
            break;
          case 'every_3_days':
            expires = 3;
            break;
          case 'every_week':
            expires = 7;
            break;
          case 'every_2_weeks':
            expires = 14;
            break;
          case 'every_month':
            expires = 30;
            break;
          default:
            expires = 7;
            break;
        }

        window.FoxTheme.utils.setStorage(this.cookieName, { opened: true }, expires);
      }
    }
  );
}
